var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmptyTemplate = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 391,
    height: 120,
    viewBox: "0 0 391 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.561 25H136.849C133.038 25 129.948 28.134 129.948 32C129.948 35.866 133.038 39 136.849 39H98.4009C94.5897 39 91.5 42.134 91.5 46C91.5 49.866 94.5897 53 98.4009 53H137.835C141.646 53 144.736 56.134 144.736 60C144.736 63.866 141.646 67 137.835 67H113.189C109.377 67 106.288 70.134 106.288 74C106.288 77.866 109.377 81 113.189 81H152.623C148.811 81 145.722 84.134 145.722 88C145.722 91.866 148.811 95 152.623 95H208.816C212.627 95 215.717 91.866 215.717 88C215.717 84.134 212.627 81 208.816 81H271.91C275.722 81 278.811 77.866 278.811 74C278.811 70.134 275.722 67 271.91 67H293.599C297.41 67 300.5 63.866 300.5 60C300.5 56.134 297.41 53 293.599 53H274.868C271.057 53 267.967 49.866 267.967 46C267.967 42.134 271.057 39 274.868 39H280.783C284.594 39 287.684 35.866 287.684 32C287.684 28.134 284.594 25 280.783 25H229.519C229.011 25 228.516 25.0556 228.04 25.1611C227.564 25.0556 227.069 25 226.561 25Z",
    fill: "#DEE4EB"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M196.328 30.8467L166.377 44.3247L194.581 57.553L226.279 44.3247L196.328 30.8467Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M196.328 38.2773L166.377 51.7553L194.581 64.9837L226.279 51.7553L196.328 38.2773Z",
    fill: "#F5F5F5",
    stroke: "#F5F5F5",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M210.211 65.7482L200.24 55.1237L233.585 42.7012L245.19 51.2008L210.211 65.7482Z",
    fill: "#F5F5F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M164.94 44.1719L195.337 58.0645V99.4193L164.94 86.0922L164.94 44.1719Z",
    fill: "white",
    stroke: "#B6B9BC",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M228.682 43.5186L195.337 57.5752V99.4195L228.682 85.6079L228.682 43.5186Z",
    fill: "white",
    stroke: "#B6B9BC",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M180.789 19L146.791 34.5281L160.685 45.4795L192.068 30.7687L180.789 19Z",
    fill: "#F5F5F5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M196.154 30.7691L205.144 20.9619L238.325 34.5286L226.393 44.4993L196.154 30.7691Z",
    fill: "white",
    stroke: "#B6B9BC",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M153.656 52.998L165.261 44.335L195.01 57.5747L185.693 67.7089L153.656 52.998Z",
    fill: "white",
    stroke: "#B6B9BC",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M152.186 34.8555L166.079 44.3358L196.155 30.7692L185.53 19.6543L152.186 34.8555Z",
    fill: "white",
    stroke: "#B6B9BC",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M220.035 84.6102V78.2895L225.351 75.9287V82.1971L220.035 84.6102Z",
    fill: "#B6B9BC",
    stroke: "#B6B9BC",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M185.799 84.8992L187.498 83.6855L188.954 85.8701L187.498 85.422L185.799 84.8992Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M187.498 90.3607V83.6855M187.498 83.6855L185.799 84.8992L188.954 85.8701L187.498 83.6855Z",
    stroke: "#B6B9BC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M226.557 44.1719L237.836 51.3638L204.655 67.0554L194.684 57.4116L226.557 44.1719Z",
    fill: "white",
    stroke: "#B6B9BC",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmptyTemplate);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/EmptyTemplate.87f068b4179ec7706e0d0b4dc65aa45e.svg";